import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { NoticeSortFieldEnum } from 'api/bulletinboard'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import { IFilterModel, ISortOrderEnum } from 'shared/models/List'

const listFilters: IFilterModel = {
  searchText: null,
  sortcolumn: NoticeSortFieldEnum.fromDate,
  sortorder: ISortOrderEnum.desc,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
}

export type NoticesList = 'active' | 'drafts' | 'historic'

const initialState: Record<NoticesList, IFilterModel> = {
  active: { ...listFilters, sortcolumn: NoticeSortFieldEnum.pinned },
  drafts: listFilters,
  historic: listFilters,
}

const noticesFiltersSlice = createSlice({
  name: 'noticesFilters',
  initialState,
  reducers: {
    patchNoticesFilters: (
      state,
      {
        payload: { list, ...filters },
      }: PayloadAction<Partial<IFilterModel> & { list: NoticesList }>
    ) => ({ ...state, [list]: { ...state[list], ...filters } }),
    // The active list's filters are copied wholesale onto drafts, so a search
    // also resets drafts' sort to active's. Behaviour of the deleted reducer,
    // kept verbatim.
    searchNotices: (state, action: PayloadAction<string>) => {
      const next = { ...state.active, searchText: action.payload, skip: 0 }
      return { ...state, active: next, drafts: next }
    },
    resetNoticesFilters: () => initialState,
  },
})

export const getNoticesFilters = (list: NoticesList) => (state: RootState) =>
  state.noticesFilters[list]

export const { patchNoticesFilters, searchNotices, resetNoticesFilters } =
  noticesFiltersSlice.actions

export default noticesFiltersSlice
